import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';
import { useConfig } from '@modules/config/composables';
import { buildObjectFromArray } from '@utils/object';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  const { config } = useConfig();

  return computed(() => ({
    common: {
      languages: buildObjectFromArray(config.value?.list_locales, 'LANGUAGES_'),
    },
  }));
}

export function getTranslationToastsKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      toasts: {
        success: 'SUCCESS',
        error: 'ERROR',
        access_error: 'ACCESS_ERROR',
        created: 'CREATED',
        edited: 'EDITED',
        removed: 'REMOVED',
        copied: 'COPIED',
        requests_to_api: {
          retry: {
            request_is_retried: 'REQUEST_IS_RETRIED',
            request_failed: 'REQUEST_FAILED_AFTER_RETRY',
            request_succeeded: 'REQUEST_SUCCEEDED_AFTER_RETRY',
          },
        },
      },
    },
  }));
}

export function getTranslationConfirmOpenLinkKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      confirm_open_link: {
        title: 'CONFIRM_OPEN_LINK.TITLE',
        message: 'CONFIRM_OPEN_LINK.MESSAGE',
        copy_button: 'CONFIRM_OPEN_LINK.COPY',
        open_button: 'CONFIRM_OPEN_LINK.OPEN',
      },
    },
  }));
}
